import { Box, Typography, Button, AppBar, CardMedia, Divider, IconButton } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import { styled } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';
import {
  ApplicationProps,
  Document,
  esignApplicationResponse,
  mdmsQuesAdditionKyc,
  getInvestorResponseType,
  InvestmentProfileMaster,
} from '../../redux-store/types/api-types';
import {
  esignApplication,
  getApplicationDetailsWithRefId,
  getApplicationInvestor,
} from '../../redux-store/actions/onBoarding';
import { useHistory } from 'react-router';
import { RootStateType } from '../../redux-store/reducers';
import { Footer } from '../commonComponents';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { ESIGN_STATUS, enableInvestmentProfile } from '../../utils/constant';
import {
  getApplicationDetails,
  getDocuments,
  getInvestorAdditionalKycQues,
  isFormValidForSubmission,
} from '../../redux-store/actions/application';
import { showError } from '../../redux-store/actions/auth';
import { ApplicationDetailsCommonLayout } from '../ApplicationDetails/index';
import {
  getAccridiatedInfo,
  getCurrencyList,
  getNationalityList,
  investmentProfileMasterData,
} from '../../redux-store/actions';
import {
  CurrencyList,
  mdmsAccridiatedInfoType,
  nationaliyType,
} from '../../redux-store/types/mdms';

export const Item = styled('div')(({ theme }) => ({
  ...theme.typography.body2,
  paddingTop: '10px',
  marginLeft: '2px',
  color: theme.palette.text.secondary,
  fontSize: '15px',
  fontWeight: 500,
  letterSpacing: '0.5px',
}));
export const ItemDetails = styled('div')(({ theme }) => ({
  ...theme.typography.body2,
  color: theme.palette.text.secondary,
  fontSize: '16px',
  marginLeft: '2px',
  fontWeight: 700,
  letterSpacing: '0.5px',
  maxWidth: '100%',
  overflowWrap: 'anywhere',
}));
export const Gridstyles = styled('div')(({ theme }) => ({
  paddingLeft: '10%',
  [theme.breakpoints.only('xs')]: {
    paddingLeft: 0,
  },
}));

export default function InvestorApplication(): JSX.Element {
  const { referenceId } = useParams<{ referenceId: string }>();
  const dispatch = useDispatch();
  const history = useHistory();
  const { investor, auth } = useSelector((store: RootStateType) => store);
  const [loading, setLoading] = useState(false);
  const [application, setApplication] = useState<ApplicationProps>();
  const applicationDetailRef = useRef<HTMLDivElement>();
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    (async function () {
      try {
        // const Investor = (await dispatch(
        //   getApplicationInvestor(referenceId)
        // )) as unknown as getInvestorResponseType;
        // const _application = (await dispatch(
        //   getApplicationDetails(Investor.applicationId)
        // )) as unknown as ApplicationProps;
        const _application = (await dispatch(
          getApplicationDetailsWithRefId(referenceId)
        )) as unknown as ApplicationProps;
        setApplication(_application);
      } catch (e) {
        console.log(e);
      } finally {
        setLoading(false);
      }
    })();
    setLoading(true);
  }, []);

  // useEffect(() => {
  //   const { token } = investor;
  //   if (!token) {
  //     history.push(`/investment-details/${referenceId}/details`);
  //   }
  // }, []);

  useEffect(() => {
    document.title = 'Unifi Investment Management :: Application Details';
  }, []);

  const handleEsign = async () => {
    try {
      setIsSubmitting(true);
      const nationalitiesMdmsMasters = (await dispatch(
        getNationalityList()
      )) as unknown as nationaliyType;
      const documentsResponse = (await dispatch(getDocuments())) as unknown as Document;
      const responseKycQues = (await dispatch(
        getInvestorAdditionalKycQues()
      )) as unknown as mdmsQuesAdditionKyc;
      const accridiatedInfoMasters = (await dispatch(
        getAccridiatedInfo()
      )) as unknown as mdmsAccridiatedInfoType;
      const currencyList = (await dispatch(getCurrencyList())) as unknown as CurrencyList;
      let investment: InvestmentProfileMaster = {} as InvestmentProfileMaster;
      if (enableInvestmentProfile) {
        investment = (await dispatch(
          investmentProfileMasterData()
        )) as unknown as InvestmentProfileMaster;
      }
      if (ESIGN_STATUS.PENDING_SIGNATURE !== application?.signDetails.status) {
        ESIGN_STATUS.NOT_GENERATED === application?.signDetails.status
          ? await isFormValidForSubmission(
              responseKycQues.investor_kyc_question_individual,
              application as ApplicationProps,
              investment,
              true,
              true,
              nationalitiesMdmsMasters,
              currencyList,
              accridiatedInfoMasters,
              documentsResponse,
              auth.role
            )
          : await isFormValidForSubmission(
              responseKycQues.investor_kyc_question_individual,
              application as ApplicationProps,
              investment,
              true,
              false,
              nationalitiesMdmsMasters,
              currencyList,
              accridiatedInfoMasters,
              documentsResponse,
              auth.role
            );
      }
      const { signDetails } = application || {};
      if (signDetails?.url) {
        window.open(signDetails?.url, '_blank');
        return;
      }
      const response = (await dispatch(
        esignApplication(referenceId)
      )) as unknown as esignApplicationResponse;
      setApplication({ ...application, signDetails: response } as unknown as ApplicationProps);
      window.open(response?.url, '_blank');
    } catch (e) {
      typeof e === 'string' && dispatch(showError(e as string));
      console.error((e as Error).message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Box
      sx={{
        bgcolor: { xs: '', sm: 'rgba(238, 244, 251, 0.5)' },
      }}>
      <IconButton
        sx={{
          position: 'fixed',
          right: 0,
          bottom: 75,
          borderRadius: '5px  0 0 5px',
          '&,:hover': {
            bgcolor: 'primary.main',
          },
        }}
        aria-label="Back to Top"
        onClick={() => applicationDetailRef.current?.scrollIntoView({ behavior: 'smooth' })}>
        <ArrowUpwardIcon fontSize="large" sx={{ color: 'common.white' }} />
      </IconButton>
      <AppBar position="fixed" elevation={0} sx={{ bgcolor: 'common.white' }}>
        <Box>
          <CardMedia
            component="img"
            src="/images/UnifiLogo.png"
            alt="Logo"
            sx={{ width: '200px', m: 2 }}
          />
        </Box>
      </AppBar>
      <Divider sx={{ display: { xs: 'block', sm: 'none' } }} />
      <Box sx={{ py: 5, px: { xs: 5, sm: 10 } }} ref={applicationDetailRef}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            mb: 2,
            justifyContent: 'space-between',
            mt: 10,
          }}>
          <Typography
            component="h1"
            sx={{ fontSize: 20, fontWeight: 600, color: 'primary.main', mb: 4 }}>
            Application Details
          </Typography>
          {application?.editable && (
            <IconButton disabled={isSubmitting}>
              <CardMedia
                component="img"
                src="/images/edit-icon-outlined.svg"
                alt="Edit Icon"
                sx={{ width: 'unset' }}
                onClick={() =>
                  history.push(`application`, {
                    id: application?.id,
                    applicant1ReferenceId: application?.applicant1ReferenceId,
                  })
                }
              />
            </IconButton>
          )}
        </Box>
        {application && (
          <>
            <ApplicationDetailsCommonLayout
              loading={loading}
              application={application as ApplicationProps}
            />
            {![ESIGN_STATUS.SIGNED, ESIGN_STATUS.EXPIRED].includes(
              application.signDetails?.status
            ) && (
              <Box sx={{ textAlign: 'center' }}>
                <Button
                  variant="contained"
                  sx={{
                    color: 'common.white',
                    minWidth: '200px',
                    mt: 4,
                    fontWeight: 600,
                    lineHeight: 1.5,
                  }}
                  onClick={handleEsign}
                  disabled={isSubmitting}>
                  {`e-Sign ${isSubmitting ? '...' : ''}`}
                </Button>
              </Box>
            )}
          </>
        )}
      </Box>
      <Footer />
    </Box>
  );
}
